module.exports = __webpack_public_path__ + "static/media/highlight-gold.bcbafa06.svg";